import { render } from "./AfterSales.vue?vue&type=template&id=79ac69a6&scoped=true"
import script from "./AfterSales.vue?vue&type=script&lang=js"
export * from "./AfterSales.vue?vue&type=script&lang=js"

import "./AfterSales.vue?vue&type=style&index=0&id=79ac69a6&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ac69a6"]])

export default __exports__